var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    fillRule: "evenodd",
    clipRule: "evenodd",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.7279 4.66153L13.776 2.55469C12.6705 1.7657 11.1806 1.82345 10.1379 2.69569L6.0898 5.24547C5.3996 5.8228 5 6.68215 5 7.58886L5 18.9609C5 20.6394 6.3431 22 8 22L16 22C17.6568 22 19 20.6394 19 18.9609L19 7.14592C19 6.15749 18.5255 5.23081 17.7279 4.66153ZM11.4114 4.25795C11.7589 3.9672 12.2556 3.94795 12.624 4.21095L16.5759 6.31779C16.8418 6.50755 17 6.81644 17 7.14592L17 18.9609C17 19.5204 16.5523 19.974 16 19.974L8 19.974C7.4477 19.974 7 19.5204 7 18.9609L7 7.58886C7 7.28662 7.1332 7.00017 7.3633 6.80772L11.4114 4.25795ZM11 8.15894C11 8.71842 11.4477 9.17197 12 9.17197C12.5523 9.17197 13 8.71842 13 8.15894C13 7.59946 12.5523 7.14592 12 7.14592C11.4477 7.14592 11 7.59946 11 8.15894Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.c14e17d259bf7b365fadd9f31917c789.svg";
export { ForwardRef as ReactComponent };